export const REVERT_SEARCH = 'revert-search';
const revertSearch = ({ currentSearch }) => (
  {
    type: REVERT_SEARCH,
    payload: { currentSearch },
  }
);
export default revertSearch;
